import { Helmet } from "react-helmet-async";
import { BRAND } from "@/brand";

const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://gcspark.com").replace(/\/$/, "");

/**
 * SiteSchema — emits site-wide Organization + WebSite JSON-LD on every page.
 *
 * Loaded once by PublicLayout. Schemas are merged into the document <head>
 * alongside whatever per-page <SEO/> emits.
 */
export default function SiteSchema() {
  const sameAs = Object.values(BRAND.social || {}).filter(Boolean);

  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${SITE_URL}/#organization`,
    name: BRAND.name,
    legalName: BRAND.legal.entityName,
    url: SITE_URL,
    logo: {
      "@type": "ImageObject",
      url: `${SITE_URL}/favicon-256.png`,
      width: 256,
      height: 256,
    },
    foundingDate: String(BRAND.legal.yearFounded),
    founder: { "@type": "Person", name: BRAND.ownerName },
    address: {
      "@type": "PostalAddress",
      addressCountry: BRAND.legal.addressCountry,
    },
    contactPoint: [
      {
        "@type": "ContactPoint",
        email: BRAND.supportEmail,
        contactType: "customer support",
        availableLanguage: ["English"],
      },
    ],
    ...(sameAs.length ? { sameAs } : {}),
  };

  const website = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    url: SITE_URL,
    name: BRAND.name,
    description: BRAND.description,
    publisher: { "@id": `${SITE_URL}/#organization` },
    inLanguage: "en-US",
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE_URL}/blog?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(organization)}</script>
      <script type="application/ld+json">{JSON.stringify(website)}</script>
    </Helmet>
  );
}
